<script setup lang="ts">
import { onUnmounted, watch } from 'vue';
import { useRoute } from 'vue-router';

import JobEditDialog from '@/components/pageDialogs/JobEditDialog.vue';
import { usePageDialogStore } from '@/stores/usePageDialogStore';

const pageDialogStore = usePageDialogStore();
const route = useRoute();

watch(
  route,
  async function () {
    pageDialogStore.close('jobEdit');
  },
  { immediate: true },
);

onUnmounted(() => {
  pageDialogStore.close('jobEdit');
});

function handleCancelClick(): void {
  pageDialogStore.close('jobEdit');
}
</script>

<template>
  <v-dialog
    v-model="pageDialogStore.jobEdit.isOpen"
    persistent
    width="90%"
    max-width="1920"
    max-height="90vh"
    scrollable
  >
    <JobEditDialog
      v-bind="pageDialogStore.jobEdit.dialogData"
      @cancel-btn-click="handleCancelClick"
    />
  </v-dialog>
</template>
